import i18n from 'i18next';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetUsersByCustomer } from '../../hooks';

export const UsersByCustomerSelect = ({
  placeholder = i18n.t('translation:default.fields.routingType.placeholder'),
  label = i18n.t('translation:default.fields.routingType.label'),
  rules = [],
  name,
  editMode,
  value,
  tooltip,
  margin = 'mb-0',
  carrierKey,
}) => {
  const { data = [], isLoading } = useGetUsersByCustomer({ Carrierkey: carrierKey });

  return (
    <FormSelectBox
      loading={isLoading}
      options={data}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      tooltip={tooltip}
    />
  );
};
